<template>
  <div class="advice-form-skeleton">
    <div class="advice-form-skeleton__radio">
      <v-skeleton-loader
        type="heading"
        width="200"
        class="advice-form-skeleton__radio-first"
      />
      <v-skeleton-loader
        type="heading"
        width="200"
        class="advice-form-skeleton__radio-second"
      />
    </div>

    <v-row>
      <v-col cols="12">
        <div class="advice-form-skeleton__input">
          <v-row
            v-for="i of 2"
            :key="i"
            class="advice-form-skeleton__input-container"
          >
            <v-col cols="6">
              <v-skeleton-loader
                type="heading"
                width="100%"
                class="advice-form-skeleton__input-first"
              />
            </v-col>

            <v-col cols="6">
              <v-skeleton-loader
                type="heading"
                width="100%"
                class="advice-form-skeleton__input-second"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'AdviceFormSkeleton',
  }
</script>

<style lang="sass" scoped>
  .advice-form-skeleton
    margin-top: 35px

    &__radio
      position: relative

      &-first
        position: absolute

      &-second
        position: absolute
        left: 100px

    &__input
      position: relative
      margin-top: 75px

      &-container
        margin-top: 50px

      &-first
        position: absolute

      &-second
        position: absolute


</style>
